import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import ProductCategories from './product-categories/ProductCategories';
import ProductFeatures from './product-features/ProductFeatures';
import ModalBackdrop from '../../ModalBackdrop';

import styles from './searchFiltersPane.module.scss'

export default function SearchFiltersPane({
                                              categoriesToDisplay,
                                              hideFilters,
                                              selectedFilters,
                                              onFiltersUpdate,
                                              selectedCategories,
                                              onCategoriesUpdate,
                                              onClose
                                          }) {

    const [filtersInFiltersPane, setFiltersInFiltersPane] = useState(selectedFilters);
    const [categoriesInFiltersPane, setCategoriesInFiltersPane] = useState(selectedCategories);

    const handleOnSubmit = () => {
        onFiltersUpdate(filtersInFiltersPane);
        onCategoriesUpdate(categoriesInFiltersPane);
        onClose();
    }

    return (
        <>
            <aside className={styles.container}>
                <header>
                    <h3 className={styles.heading}>Filter your results</h3>
                </header>
                <article>
                    <section className={styles.categories}>
                        <h6 className={styles.heading}>Search by category</h6>
                        <ProductCategories
                            categoriesToDisplay={categoriesToDisplay}
                            selectedCategories={categoriesInFiltersPane}
                            onCategoriesUpdate={newCategories => setCategoriesInFiltersPane(newCategories)}
                        />
                    </section>
                    <section className={styles.filters}>
                        <h6 className={styles.heading}>Filter results</h6>
                        <ProductFeatures
                            hideFilters={hideFilters}
                            selectedFilters={filtersInFiltersPane}
                            onFiltersUpdate={updatedFilters => setFiltersInFiltersPane(updatedFilters)}
                        />
                    </section>
                </article>
                <footer>
                    <Button onClick={handleOnSubmit} className={'btn-action'}>Update your search</Button>
                    <Button variant={"secondary"} onClick={() => {
                        setCategoriesInFiltersPane(() => ({superCategory: '', category: ''}));
                        setFiltersInFiltersPane(() => ({
                            isPromoOnly: false,
                            isCoopOwnLabel: false,
                            isHeritageOwnLabel: false,
                            isOrganic: null,
                            isGlutenFree: null,
                            isVegetarian: null,
                            isFairtrade: null,
                            isHalal: null,
                            isVegan: null
                        }));
                    }}>Clear selection</Button>
                    <Button variant={"secondary"} onClick={onClose}>Cancel</Button>
                </footer>
            </aside>
            <ModalBackdrop onClick={onClose}/>
        </>
    );
}